// Copyright © 2021 Move Closer
export const PromotionsRepositoryType = Symbol.for('IPromotionsRepository');
export const SubscriptionsRepositoryType = Symbol.for('ISubscriptionsRepository');
export const TransactionsRepositoryType = Symbol.for('ITransactionsRepository');
